// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"120":"8f2a764b9bc98332","194":"7357f54a9191b1c0"}[chunkId] + ".js";
};